import { render, staticRenderFns } from "./IntakeEmergencyBox.vue?vue&type=template&id=c397ef62"
import script from "./IntakeEmergencyBox.vue?vue&type=script&lang=js"
export * from "./IntakeEmergencyBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports